import classNames from 'classnames';
import React, {ReactElement} from 'react';

import {MoneyIcon, ToolsIcon} from '../../../resources/Icons';
import {formatMoney} from '../mechanics';
import {Tool} from '../types';
import InfoPill from './buttons/InfoPill';
import {BuyButton} from './buttons/PillButtons';

type ToolProps = {
  tool: Tool;
  purchased: boolean;
  cost: number;
  canPay?: boolean;
  className?: string;
  onClick: () => void;
};

const ToolCard = ({tool, purchased, cost, canPay = true, className, ...rest}: ToolProps): ReactElement => {
  return (
    <div
      className={classNames(
        'flex flex-col border-normal font-sans rounded-2xl pt-md px-xs min-w-[3rem] text-center justify-center items-center group',
        !purchased ? 'border-gray-100 hover:border-primary-300 cursor-pointer' : 'bg-primary-100 border-primary-300',
        !canPay && 'pointer-events-none',
        className
      )}
      onClick={!purchased && canPay ? rest.onClick : undefined}
    >
      <ToolsIcon className={'w-xl h-xl'} />
      <h1 className={'mt-sm'}>{tool.name}</h1>
      {tool.description && <h2 className={'mt-sm leading-tight grow'}>{tool.description}</h2>}
      {purchased ? (
        <InfoPill
          icon={<MoneyIcon className="h-[45px] w-[45px]" />}
          sublabel={formatMoney(-cost)}
          label={'Purchased'}
          reversed={true}
          danger={true}
          className={'mt-lg -mb-[4rem]'}
        />
      ) : (
        <BuyButton
          cost={cost}
          purchased={purchased}
          disabled={!canPay}
          className={'mt-lg group-hover:bg-primary-600 -mb-[4rem]'}
        ></BuyButton>
      )}
    </div>
  );
};

export default ToolCard;
